/* VELNA Somn — minimal progressive enhancement.
   Nothing here is required for the page to work: without JavaScript every
   product form posts to /cart/add and the ritual finder falls back to its
   first panel. */
(function () {
  'use strict';

  var strings = window.somnStrings || {};
  var T = {
    adding: strings.adding || 'ADDING…',
    added: strings.added || 'ADDED TO CART',
    error: strings.error || 'Something went wrong. Please try again.',
    soldOut: strings.soldOut || 'SOLD OUT',
    unavailable: strings.unavailable || 'UNAVAILABLE'
  };

  function statusFor(form) {
    var uid = form.getAttribute('data-somn-form');
    if (!uid) return null;
    return document.querySelector('[data-somn-status="' + uid + '"]');
  }

  function say(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  function addItems(items) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      return res.json();
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.somn-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------ add to cart */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.somn-form');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('.somn-add');
    var status = statusFor(form);
    var data = new FormData(form);
    var id = data.get('id');
    if (!id) return;

    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    }
    say(status, T.adding);

    addItems([{ id: id, quantity: parseInt(data.get('quantity'), 10) || 1 }])
      .then(function () {
        say(status, T.added);
        refreshCartCount();
      })
      .catch(function () { say(status, T.error); })
      .then(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
        }
        window.setTimeout(function () { say(status, ''); }, 4000);
      });
  });

  /* ---------------------------------------------- pairing add to cart */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-somn-pair]');
    if (!trigger) return;
    var ids = (trigger.getAttribute('data-somn-pair') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    event.preventDefault();

    var status = document.querySelector('[data-somn-status="' + trigger.getAttribute('data-somn-uid') + '"]');
    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-busy', 'true');
    say(status, T.adding);

    addItems(ids.map(function (id) { return { id: id.trim(), quantity: 1 }; }))
      .then(function () {
        say(status, T.added);
        refreshCartCount();
      })
      .catch(function () { say(status, T.error); })
      .then(function () {
        trigger.classList.remove('is-loading');
        trigger.removeAttribute('aria-busy');
        window.setTimeout(function () { say(status, ''); }, 4000);
      });
  });

  /* ------------------------------------------------------ ritual finder */
  function initFinder(root) {
    var choices = Array.prototype.slice.call(root.querySelectorAll('.finder-choice'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.finder-panel'));
    if (!choices.length) return;

    function select(index, focus) {
      choices.forEach(function (choice, i) {
        var on = i === index;
        choice.classList.toggle('is-active', on);
        choice.setAttribute('aria-selected', on ? 'true' : 'false');
        choice.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-panel') === choices[index].getAttribute('data-finder');
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
      if (focus) choices[index].focus();
    }

    choices.forEach(function (choice, index) {
      choice.addEventListener('click', function () { select(index, false); });
      choice.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % choices.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + choices.length) % choices.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = choices.length - 1;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });
  }


  /* --------------------------------------------------- product page media */
  function initGallery(root) {
    var main = root.querySelector('[data-somn-main]');
    var thumbs = root.querySelectorAll('[data-somn-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.removeAttribute('srcset');
        main.src = thumb.getAttribute('data-somn-thumb');
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  }

  /* ------------------------------------------------------ variant picking */
  function initVariants(root) {
    var data = root.querySelector('[data-somn-variants]');
    var idField = root.querySelector('[data-somn-variant-id]');
    if (!data || !idField) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-somn-option]'));
    var priceEl = root.querySelector('.somn-pdp-price .somn-price');
    var button = root.querySelector('.somn-pdp-buy .somn-add');

    function update() {
      var chosen = selects.map(function (select) { return select.value; });
      var match = variants.filter(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      })[0];

      if (!match) {
        if (button) { button.disabled = true; button.textContent = T.unavailable; }
        return;
      }

      idField.value = match.id;

      if (priceEl) {
        priceEl.innerHTML = match.has_compare
          ? match.price + '<s>' + match.compare_at_price + '</s>'
          : match.price;
      }
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? button.getAttribute('data-label') || button.textContent : T.soldOut;
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', update);
    });
    if (button && !button.getAttribute('data-label')) {
      button.setAttribute('data-label', button.textContent.trim());
    }
  }

  function init() {
    document.querySelectorAll('[data-somn-finder]').forEach(initFinder);
    document.querySelectorAll('[data-somn-pdp]').forEach(function (root) {
      initGallery(root);
      initVariants(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
